<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="780">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-EXTENSION' : 'EDIT-EXTENSION' ) | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm">
        <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="{{ 'EXTENSION' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <!--Extension Key-->
                        <div class="row">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'KEY' | translate}} *
                                    </span>
                                    <input id="key" kendoTextBox formControlName="key" maxlength="255"
                                        (change)="keyOrgChange('key')" (keydown)="validateKey($event)" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="key.hasError('required') && key.touched">
                                        {{'REQUIRED-KEY' | translate}}
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="key.hasError('keyExists')">
                                        {{'KEY-ALREADY-EXISTS-FOR-ORGANIZATION' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <!--Extension Name-->
                            <div class="col-12">
                                <label for="name" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'NAME' | translate }} *
                                    </span>
                                    <input id="name" kendoTextBox formControlName="name" maxlength="255" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="name.hasError('required') && name.touched">
                                        {{'REQUIRED-NAME' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <!--Assessment Source-->
                            <div class="col">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'CATEGORY' | translate}} *
                                    </span>
                                    <div>
                                        <span>
                                            <input type="radio" value="CARE_TEAM" name="category"
                                                formControlName="category" id="radioCareTeam"
                                                (change)="keyOrgChange('category')" kendoRadioButton /> <label
                                                class="k-radio-label" for="radioCareTeam">{{'CARE-TEAM' |
                                                translate}}
                                            </label>
                                            <input type="radio" value="PATIENT" name="category"
                                                formControlName="category" id="radioPatient"
                                                (change)="keyOrgChange('category')" kendoRadioButton /> <label
                                                class="k-radio-label" for="radioPatient">{{'MEMBER' |
                                                translate:patientLabel}}
                                            </label>
                                            <input type="radio" value="CASE" name="category" formControlName="category"
                                                id="radioCase" (change)="keyOrgChange('category')" kendoRadioButton />
                                            <label class="k-radio-label" for="radioCase">{{'CASE' | translate}}
                                            </label>
                                            <input type="radio" value="COMMUNITY_SERVICE" name="category"
                                                formControlName="category" id="radioCommunityService"
                                                (change)="keyOrgChange('category')" kendoRadioButton /> <label
                                                class="k-radio-label" for="radioCommunityService">{{'COMMUNITY-SERVICE'
                                                | translate}}
                                            </label>
                                            <input type="radio" value="ORGANIZATION" name="category"
                                                formControlName="category" id="radioOrg"
                                                (change)="keyOrgChange('category')" kendoRadioButton /> <label
                                                class="k-radio-label" for="radioOrg">{{'ORGANIZATION' | translate}}
                                            </label>
                                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                                *ngIf="category.hasError('required') && category.touched">
                                                {{'REQUIRED-CATEGORY' | translate}}
                                            </div>
                                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                                *ngIf="category.hasError('keyExists')">
                                                {{'KEY-ALREADY-EXISTS-FOR-ORGANIZATION' | translate}}
                                            </div>
                                        </span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row" *ngIf="category && category.value">
                            <div class="col-6">
                                <!--All organizations-->
                                <label class="k-text-uppercase dark mr-2 w-100" for="allOrganizations">{{
                                    'ALL-ORGANIZATIONS' |
                                    translate }}
                                </label>
                                <kendo-switch formControlName="allOrganizations" onLabel="{{'YES' | translate }}"
                                    offLabel="{{'NO' | translate }}">
                                </kendo-switch>
                            </div>
                            <div class="col-6"
                                *ngIf="(allOrganizations && allOrganizations.value && category.value === 'PATIENT')">
                                <!--Enabled Next Available-->
                                <label class="k-text-uppercase dark mr-2 w-100" for="enabledNextAvailable">{{
                                    'ENABLE-NEXT-AVAILABLE' | translate }}
                                </label>
                                <kendo-switch formControlName="enabledNextAvailable" onLabel="{{'YES' | translate }}"
                                    offLabel="{{'NO' | translate }}">
                                </kendo-switch>
                            </div>
                        </div>
                        <div class="row" *ngIf="!(allOrganizations && allOrganizations.value)">
                            <!--Extension Organization-->
                            <div class="col">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ORGANIZATION' | translate}} <span *ngIf="isOrganizationRequired()">*</span>
                                    </span>
                                    <kendo-combobox id="organization" formControlName="organization" class="w-100"
                                        (valueChange)="keyOrgChange('organization')" [valuePrimitive]="false"
                                        [data]="organizations" [itemDisabled]="itemDisabled" [textField]="'name'"
                                        [valueField]="'id'">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="organization.hasError('required') && organization.touched">
                                        {{'REQUIRED-ORGANIZATION' | translate}}
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="organization.hasError('keyExists')">
                                        {{'KEY-ALREADY-EXISTS-FOR-ORGANIZATION' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6"
                                *ngIf="category.value === 'PATIENT' && allOrganizations && allOrganizations.value">
                                <div class="mt-3">
                                    <!--Billable Item-->
                                    <label class="k-text-uppercase dark mr-2 w-100" for="billableItem">{{
                                        'BILLABLE-ITEM' |
                                        translate }}
                                    </label>
                                    <kendo-switch formControlName="billableItem" onLabel="{{'YES' | translate }}"
                                        offLabel="{{'NO' | translate }}">
                                    </kendo-switch>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="mt-3">
                                    <!--Enabled-->
                                    <label class="k-text-uppercase dark mr-2 w-100" for="enabled">{{ 'ENABLED' |
                                        translate }}
                                    </label>
                                    <kendo-switch formControlName="enabled" onLabel="{{'YES' | translate }}"
                                        offLabel="{{'NO' | translate }}">
                                    </kendo-switch>
                                </div>
                            </div>
                            <div class="col-6" *ngIf="!(allOrganizations && allOrganizations.value)">
                                <div class="mt-3">
                                    <!--Required-->
                                    <label class="k-text-uppercase dark mr-2 w-100" for="required">{{ 'REQUIRED' |
                                        translate }}
                                    </label>
                                    <kendo-switch formControlName="required" onLabel="{{'YES' | translate }}"
                                        offLabel="{{'NO' | translate }}">
                                    </kendo-switch>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'EXTENSION-DATA-TYPES-TAB' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'DATA-TYPE' | translate }} *
                                        <span *ngIf="dataTypeInfoTooltipKey" style="display: inline-flex">
                                            <a kendoTooltip position="right"
                                                title="{{ dataTypeInfoTooltipKey | translate }}">
                                                <i class="fa fa-info-circle pointer" role="button"
                                                    attr.aria-label="{{ dataTypeInfoTooltipKey | translate }}"></i>
                                            </a>
                                        </span>
                                    </span>
                                    <div class="w-50">
                                        <kendo-combobox id="dataType" class="w-100" formControlName="dataType" [data]="extensionDataTypes"
                                            [textField]="'text'" [valueField]="'value'" [valuePrimitive]="true"
                                            [listHeight]="extensionDataTypeListHeight">
                                        </kendo-combobox>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="dataType?.hasError('required') && dataType?.touched">
                                        {{ 'REQUIRED-DATA-TYPE' | translate }}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row" *ngIf="isDataTypesConfigurable && dataType?.value === 'DICTIONARY'">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'CODE-SET' | translate }} *
                                    </span>
                                    <div class="w-50">
                                        <kendo-combobox id="codeSetId" class="w-100" formControlName="codeSetId" [data]="codeSets"
                                            [textField]="'name'" [valueField]="'id'" [valuePrimitive]="true"
                                            [defaultItem]="{ id: null, name: '' }">
                                        </kendo-combobox>
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="codeSetId?.hasError('required') && codeSetId?.touched">
                                        {{ 'REQUIRED-CODE-SET' | translate }}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row"
                          *ngIf="isDataTypesConfigurable && (dataType?.value === 'TEXT' || dataType?.value === 'TEXT_AREA')">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'MAX-LENGTH' | translate }}
                                    </span>
                                    <div class="w-50">
                                        <kendo-numerictextbox id="maxLength" class="w-100" formControlName="maxLength" [min]="1"
                                            [max]="extensionValueDbMaxLength" [format]="'n0'" [decimals]="0">
                                        </kendo-numerictextbox>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row" *ngIf="isDataTypesConfigurable && dataType?.value === 'NUMBER'">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'DECIMALS' | translate }}
                                    </span>
                                    <div class="w-50">
                                        <kendo-numerictextbox id="decimals" class="w-100" formControlName="decimals" [min]="0"
                                            [format]="'n0'" [decimals]="0">
                                        </kendo-numerictextbox>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'CHANNELS' | translate }}"
                *ngIf="enabledNextAvailable && enabledNextAvailable.value">
                <ng-template kendoTabContent>
                    <div class="p-3">
                        <div class="row">
                            <div class="col-1 text-center">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'ALL' | translate }}
                                    </span>
                                    <input type="checkbox" [indeterminate]="allChannels.value === null"
                                        formControlName="allChannels" kendoCheckBox />
                                </label>
                            </div>
                            <div class="col-11">
                                <label for="channels" class="k-form-field mt-0 w-100"
                                    [ngClass]="{'k-disabled': allChannels && allChannels.value}">
                                    <span class="k-text-uppercase dark">
                                        {{ 'CHANNELS' | translate }}
                                    </span>
                                    <kendo-multiselect [data]="groupedChannels" formControlName="channels"
                                        [textField]="'name'" [filterable]="true" [valueField]="'id'" [valuePrimitive]="true"
                                        (filterChange)="filterChannels($event)" (close)="searchTerms=''"
                                        [autoClose]="true" [virtual]="virtualChannel"
                                        [itemDisabled]="channelItemDisabled">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.name | highlight : searchTerms }}">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
        <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>